import { render } from "./XPostReview.vue?vue&type=template&id=985edb8a"
import script from "./XPostReview.vue?vue&type=script&lang=js"
export * from "./XPostReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__